/**
 * PushService — FCM (Android) + APNs (iOS) push notifications.
 * No-op on web. Uses window.Capacitor.Plugins to avoid build-time imports.
 */
import { isNative, isIOS } from '../utils/platform';

function getPushPlugin() {
  return window.Capacitor?.Plugins?.PushNotifications || null;
}

export class PushService {
  constructor({ onToken, onNotification, onTap }) {
    this.onToken = onToken;
    this.onNotification = onNotification;
    this.onTap = onTap;
    this.registered = false;
  }

  async init() {
    if (!isNative) return false;
    if (this.registered) return true;
    const push = getPushPlugin();
    if (!push) return false;

    let permStatus = await push.checkPermissions();
    if (permStatus.receive === 'prompt') permStatus = await push.requestPermissions();
    if (permStatus.receive !== 'granted') return false;

    push.addListener('registration', (token) => {
      const platform = isIOS ? 'ios' : 'android';
      this.onToken(token.value, platform);
    });
    push.addListener('registrationError', (err) => console.error('[Push] Registration error:', err));
    push.addListener('pushNotificationReceived', (notification) => {
      const payload = notification.data;
      if (payload?.type) this.onNotification(payload, notification);
    });
    push.addListener('pushNotificationActionPerformed', (action) => {
      const payload = action.notification?.data;
      if (payload?.type) this.onTap(payload, action);
    });

    await push.register();
    this.registered = true;
    return true;
  }

  async unregister() {
    const push = getPushPlugin();
    if (push) await push.removeAllListeners();
    this.registered = false;
  }
}

export async function registerPushToken(token, platform, authToken) {
  try {
    await fetch('/api/push-token', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${authToken}` },
      body: JSON.stringify({ token, platform }),
    });
  } catch (e) {
    console.error('[Push] Failed to register token:', e);
  }
}

export function resolveNotificationRoute(payload) {
  switch (payload.type) {
    case 'booking_request': return null; // trainer stays on calendar
    case 'booking_confirmed': case 'booking_rejected': return null; // client stays on today
    case 'new_message': return null;
    default: return null;
  }
}
